import RelationshipMetadata from "../../RelationshipMetadata";

class ETLJobExecutionETLJobPreExecutionLogRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ETLJobExecutionETLJobPreExecutionLog";
        this.parentEnterpriseComponent = "ETLJobExecution";
        this.childEnterpriseComponent = "ETLJobPreExecutionLog";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ETLJobExecutionUSID";
    }
}

export default ETLJobExecutionETLJobPreExecutionLogRelationshipMetadata;